import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { FormProvider, useForm } from 'react-hook-form';
import { useAppDispatch } from '../../../../hooks/redux';
import { useCustomSnackbar } from '../../../../hooks/useCustomEnqueueSnackbar';
import { ordersApi } from '../../../../services/apiServices/user/orders';
import { ButtonClassNames, ModalVariants } from '../../../../models/Common';
import { FormInputTextArea } from '../../../inputs/FormInputTextArea';
import { CustomMUIButton } from '../../buttons/CustomMUIButton';
import { modalSlice } from '../../../../store/reducers/ModalSlice';
import { getErrorMessage } from '../../../../utils';

export const AnonymousFeedback: FC = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const { customEnqueueSnackbar } = useCustomSnackbar();
  const { openModal } = modalSlice.actions;
  const [unidentifiedFeedback, { isLoading }] = ordersApi.useFeedbackMutation();
  const methods = useForm({
    defaultValues: {
      userComment: '',
    },
    mode: 'onChange',
  });
  const { handleSubmit, setError } = methods;

  const handleSendRequest = async ({ userComment }: { userComment: string }) => {
    if (userComment.trim().length < 10) {
      setError('userComment', {
        type: 'local',
        message: !userComment.trim()
          ? t('validation.thisFieldIsRequired')
          : `${t('validation.theNumberOfCharactersMustBeAtLeast')} 10`,
      });
      return;
    }
    if (userComment.trim().length > 1160) {
      setError('userComment', {
        type: 'local',
        message: t('validation.exceededPermittedNumberOfCharacters'),
      });
      return;
    }
    const site = `Сайт: ${process.env.REACT_APP_NAME || ''}.`;
    const commentMessage = `${site} Комментарий: ${userComment.trim()}`;

    try {
      await unidentifiedFeedback({ comment: commentMessage }).unwrap();
      dispatch(
        openModal({
          modalVariants: ModalVariants.Success,
          content: {
            title: `${t('feedbackAndSuggestions.accepted')}`,
            description: `${t('feedbackAndSuggestions.thankYou')}`,
          },
        }),
      );
    } catch (err: unknown) {
      const message = getErrorMessage(err);
      customEnqueueSnackbar(message, 'error');
    }
  };

  return (
    <div className="modals">
      <div className="modals__header">
        <article className="modals__header__title">{t('feedbackAndSuggestions.open')}</article>
      </div>
      <FormProvider {...methods}>
        <form className="modals__form" onSubmit={handleSubmit(handleSendRequest)}>
          <FormInputTextArea
            isRequired
            name="userComment"
            className="primary"
            maxLength={1160}
            rows={3}
            placeholder={t('feedbackAndSuggestions.feedback')}
          />
          <div className="modals__btn-group">
            <CustomMUIButton
              label={t('feedbackAndSuggestions.send')}
              type="submit"
              className={ButtonClassNames.PrimaryFulfilled}
              isBold
              isLoading={isLoading}
            />
          </div>
        </form>
      </FormProvider>
    </div>
  );
};
